<template>
  <el-container>
    <div class="home-container">
      <!-- 左侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '256px'">
        <!-- 账户信息区域 -->
        <div class="userInfo" v-show="$store.state.user.userCard">
          <div class="headPhoto">
            <el-image class="user-avatar" :src="userImg" fit="cover">
              <div slot="error" class="image-slot">
                <img src="../../assets/logo.png" alt="" />
              </div>
            </el-image>
          </div>
          <div class="userName">
            {{ userInfo ? userInfo.username : '未登录' }}
          </div>
          <div class="validityPeriod">
            有效期至：<span>{{ endTime | formatDay }}</span>
          </div>
          <el-button type="danger" class="reviseBtn" @click="changePassword">
            修改密码
          </el-button>
        </div>
        <!-- 导航菜单 -->
        <el-menu
          v-if="$store.getters.status === 1"
          background-color="#ffffff"
          text-color="#838490"
          active-text-color="#6345d5"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          router
          :default-active="activeIndex"
          :default-openeds="defaultOpenedMenus"
        >
          <sideBar :list="menulist" />
        </el-menu>
      </el-aside>
    </div>
    <el-container>
      <!-- 顶部导航栏 -->
      <el-header>
        <span class="header-title">公共娱乐场所治安管理系统</span>
        <div class="header-right">
          <div class="user-system">
            <div class="clock-in-tip" ref="webBtn">{{ clockTip }}</div>
            <div class="title-user">
              <img class="icon-user" src="@/assets/img/phone.png" alt="" />
            </div>
            <div class="user-menu">
              <span>{{ phone1 }}</span>
              <span>{{ phone2 }}</span>
            </div>
            <div class="logout" @click="showUserDialog">
              <img src="@/assets/img/signout.png" alt="" />
              <span>退出</span>
            </div>
          </div>
        </div>
      </el-header>
      <!-- 主内容区域 -->
      <el-main class="layout-content">
        <keep-alive :include="keepList" max="1">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
    <!-- 打卡弹窗 -->
    <el-dialog
      :visible.sync="codeVisible"
      center
      width="30%"
      @close="closeClockForm"
      class="clock-dialog"
    >
      <template #title>
        <div class="dialog-title">打卡</div>
      </template>
      <div class="form">
        <el-form
          :model="codeForm"
          ref="codeFormRef"
          :rules="codeFormRules"
          label-width="auto"
          class="clock-form"
        >
          <el-form-item label="打卡类型" prop="gz_lx">
            <el-radio-group v-model="codeForm.gz_lx">
              <el-radio :label="0" border>上班</el-radio>
              <el-radio :label="1" border>下班</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeClockForm">取 消</el-button>
        <el-button type="primary" @click="submitClockForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码弹窗 -->
    <el-dialog :visible.sync="dialogFormVisible" class="dialog" width="30%">
      <div slot="title">
        <img
          src="../../assets/img/tietle1.png"
          alt=""
          class="dialog-header-img"
        />
      </div>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <el-form
            ref="loginFormRef"
            status-icon
            :model="loginForm"
            :rules="loginFormRules"
            label-width="0px"
            class="input-div"
          >
            <el-form-item prop="mobile">
              <el-input
                v-model.number.trim="loginForm.mobile"
                placeholder="手机号"
              />
            </el-form-item>
            <el-form-item prop="sms_code">
              <el-input v-model="loginForm.sms_code" placeholder="验证码" />
              <button
                @click.prevent="getShortMessageCode()"
                class="sms_code-btn"
                :disabled="!show"
              >
                <span v-show="show">获取验证码</span>
                <span v-show="!show" class="count">{{ count }} s</span>
              </button>
            </el-form-item>
            <el-form-item prop="password" class="unlook">
              <el-input
                type="password"
                v-model.trim="loginForm.password"
                placeholder="新密码"
              />
            </el-form-item>
            <el-form-item prop="checkPass" class="unlook">
              <el-input
                type="password"
                v-model.trim="loginForm.checkPass"
                placeholder="确认密码"
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer dialog-footer-center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlePasswordSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
/**
 * @file 系统首页布局组件
 * @description 包含侧边栏导航、顶部栏、WebSocket连接、打卡功能、修改密码等功能
 */
import { mapState } from 'vuex'
import { regular } from '@/utils/validate.js'
import * as user from '@/api/user'
import sideBar from './sideBar.vue'
import { addEmpLogItem, addEmp } from '@/api/day_work.js'
// 常量定义
const WEBSOCKET_URL = 'ws:127.0.0.1:7415'
const VERIFICATION_CODE_LENGTH = 6
const SMS_COUNTDOWN_SECONDS = 30
const WEBSOCKET_TIMEOUT_LONG = 180000000 // 长超时时间（毫秒）
const WEBSOCKET_TIMEOUT_SHORT = 120000 // 短超时时间（毫秒）
const PASSWORD_MIN_LENGTH = 8
const PASSWORD_MAX_LENGTH = 16
// 密码强度验证正则表达式：必须同时包含字母、数字，长度在8-16位之间
const PASSWORD_STRENGTH_REGEX = new RegExp(
  `(?=.*[0-9])(?=.*[a-zA-Z]).{${PASSWORD_MIN_LENGTH},${PASSWORD_MAX_LENGTH}}`
)
/**
 * 验证密码强度
 * @param {string} value - 密码值
 * @returns {boolean} 是否通过验证
 */
const validatePasswordStrength = value => {
  return PASSWORD_STRENGTH_REGEX.test(value)
}
export default {
  name: 'Home',
  components: { sideBar },
  data() {
    // 确认密码验证器
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请再次输入密码'))
      }
      if (value !== this.loginForm.password) {
        return callback(new Error('两次输入密码不一致!'))
      }
      return callback()
    }
    return {
      // 默认展开的菜单
      defaultOpenedMenus: ['13'],
      // 侧边栏折叠状态
      isCollapse: false,
      // 菜单列表
      menulist: [],
      // 当前激活的菜单项
      activeIndex: '',
      // 联系电话1
      phone1: '029-88413302',
      // 联系电话2
      phone2: '029-88404282',
      // 账户到期时间
      endTime: '2022-02-21',
      // 用户头像
      userImg: '',
      // 修改密码弹窗显示状态
      dialogFormVisible: false,
      // 登录/修改密码表单
      loginForm: {
        mobile: '',
        password: '',
        checkPass: '',
        sms_code: ''
      },
      // 是否显示获取验证码按钮
      show: true,
      // 验证码倒计时定时器
      timer: null,
      // 验证码倒计时秒数
      count: 0,
      // 用户状态
      status: '',
      // WebSocket长超时时间
      paramTimeOut: WEBSOCKET_TIMEOUT_LONG,
      // WebSocket短超时时间
      paramTimeOutF: WEBSOCKET_TIMEOUT_SHORT,
      // 打卡状态提示
      clockTip: '设备连接中，请等待...',
      // WebSocket实例
      websockets: null,
      // WebSocket连接状态
      readyState: -1,
      // 是否已连接
      isConnect: false,
      // 连接重试次数
      isNum: 0,
      // 是否设置信息标记（0-打卡，1-添加用户）
      isSetInfo: 0,
      // 加载状态实例
      loadingState: null,
      // 读取的身份证数据
      readData: '',
      // 打卡弹窗显示状态
      codeVisible: false,
      // 打卡表单
      codeForm: {
        gz_lx: ''
      },
      // 登录表单验证规则
      loginFormRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: regular.phone,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        sms_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            max: VERIFICATION_CODE_LENGTH,
            message: `验证码长度不得超过${VERIFICATION_CODE_LENGTH}位`,
            trigger: 'blur'
          }
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入密码'))
              } else if (
                value.length < PASSWORD_MIN_LENGTH ||
                value.length > PASSWORD_MAX_LENGTH
              ) {
                callback(
                  new Error(
                    `请输入${PASSWORD_MIN_LENGTH}~${PASSWORD_MAX_LENGTH}位密码`
                  )
                )
              } else if (validatePasswordStrength(value)) {
                callback()
              } else {
                callback(new Error('密码必须同时包含字母、数字且至少8位'))
              }
            },
            trigger: 'change'
          }
        ],
        checkPass: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      // 打卡表单验证规则
      codeFormRules: {
        gz_lx: [
          { required: true, message: '请选择打卡类型', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 初始化菜单列表
    this.getMenuList()
    // 获取用户状态和到期时间
    this.status = this.$store.state.user.userInfo.status
    this.endTime = this.$store.state.user.userInfo.daoqi_time
  },
  mounted() {
    // 页面刷新或关闭时发送空数据到WebSocket
    window.addEventListener('beforeunload', () => {
      if (this.readyState === 1) {
        this.websockets.send([{}])
      }
      sessionStorage.setItem('clockFun', true)
    })
    // 从store获取WebSocket实例
    this.websockets = this.$store.state.user.webscoketFun
    // 初始化WebSocket连接
    this.initWebSocket()
    // 设置当前激活菜单
    this.activeIndex = this.$store.getters.activeIndex
  },
  computed: {
    ...mapState({
      keepList: state => state.keepList,
      userInfo: state => state.user.userInfo
    }),
    /**
     * 判断是否需要显示打卡弹窗
     * @returns {boolean} 是否需要显示
     */
    shouldShowClockDialog() {
      const path = this.$route.path
      return (
        !path.includes('add_employees') && !path.includes('add_pointperson')
      )
    }
  },
  watch: {
    /**
     * 监听路由变化，保持菜单激活状态
     * @param {Object} e - 路由对象
     */
    $route(e) {
      this.activeIndex = '/' + e.path.split('/')[1]
      this.$store.commit('user/setActiveIndex', `/${e.path.split('/')[1]}`)
    },
    /**
     * 监听修改密码弹窗关闭，重置表单
     * @param {boolean} val - 弹窗显示状态
     */
    dialogFormVisible(val) {
      if (!val) {
        this.loginForm = {
          mobile: '',
          password: '',
          checkPass: '',
          sms_code: ''
        }
        this.$refs.loginFormRef?.clearValidate()
      }
    }
  },
  updated() {
    // 页面更新后滚动条置顶
    const dom = document.getElementsByClassName('layout-content')[0]
    if (dom) {
      dom.scrollTo(0, 0)
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    /**
     * 初始化WebSocket连接（打卡服务）
     * @description 建立与本地身份证读卡器服务的WebSocket连接
     */
    initWebSocket() {
      if (this.isConnect) return
      this.websockets = new WebSocket(WEBSOCKET_URL)
      // 连接成功回调
      this.websockets.onopen = () => {
        this.clockTip = '打卡已就绪'
        this.updateSocketState()
      }
      // 接收消息回调
      this.websockets.onmessage = res => {
        this.handleWebSocketMessage(res)
      }
      // 连接关闭回调，自动重连
      this.websockets.onclose = () => {
        setTimeout(() => {
          this.initWebSocket()
        }, 20)
      }
    },
    /**
     * 处理WebSocket接收到的消息
     * @param {Object} res - WebSocket消息对象
     */
    handleWebSocketMessage(res) {
      if (res.data === 'failed to obtain ID card information') {
        this.$message.warning(`接收数据: ${res.data}`)
        return
      }
      // 处理身份证数据（包含|分隔符）
      if (res?.data?.includes('|')) {
        const cardData = res.data.split('|')
        this.readData = cardData
        this.loadingState = this.$loading({
          lock: true,
          text: '打卡中，请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        if (this.shouldShowClockDialog) {
          // 在打卡页面，显示打卡弹窗
          this.isSetInfo = 0
          this.codeForm.gz_lx = ''
          this.codeVisible = true
          this.$nextTick(() => {
            this.$refs.codeFormRef?.clearValidate()
          })
        } else {
          // 在添加用户页面，直接提交身份证数据
          this.isSetInfo = 1
          this.submitIdCardForAddUser(cardData)
        }
      } else {
        // 发送打卡指令
        this.sendClockCommand()
      }
    },
    /**
     * 更新WebSocket连接状态
     */
    updateSocketState() {
      const oldState = this.readyState
      this.readyState = this.websockets.readyState
      if (this.readyState === 1) {
        this.isConnect = true
        this.sendClockCommand()
        if (sessionStorage.getItem('clockFun') && oldState === -1) {
          this.$message.warning('读取失败，请重试')
          sessionStorage.setItem('clockFun', false)
        }
      }
      if (this.readyState === 3) {
        this.isConnect = false
      }
    },
    /**
     * 发送打卡指令到读卡器
     */
    sendClockCommand() {
      const parameterAll = 'timeout=' + this.paramTimeOutF
      const command = '02?' + parameterAll
      this.websockets.send(command)
    },
    /**
     * 提交打卡数据到后台
     * @param {Array} data - 身份证数据数组
     */
    submitClockData(data) {
      const params = {
        id_card: data[6],
        gz_lx: this.codeForm.gz_lx
      }
      addEmpLogItem(params)
        .then(() => {
          this.loadingState?.close()
          const msg = sessionStorage.getItem('successTip')
          this.$message.success(msg)
          this.codeVisible = false
          this.sendClockCommand()
          this.$store.dispatch('user/changeClockState', true)
        })
        .catch(() => {
          this.loadingState?.close()
          this.sendClockCommand()
        })
    },
    /**
     * 提交身份证数据用于添加用户
     * @param {Array} data - 身份证数据数组
     */
    submitIdCardForAddUser(data) {
      const params = {
        id_card: data[6]
      }
      addEmp(params)
        .then(() => {
          this.loadingState?.close()
          const code = sessionStorage.getItem('requestCode')
          const msg = sessionStorage.getItem('successTip')
          this.$message.success(msg)
          if (code === '0') {
            this.$store.dispatch('user/changeAddEState', true)
            sessionStorage.setItem('addEmpData', JSON.stringify(data))
          }
          this.sendClockCommand()
        })
        .catch(() => {
          this.loadingState?.close()
          this.sendClockCommand()
        })
    },
    /**
     * 提交打卡表单
     */
    submitClockForm() {
      this.$refs.codeFormRef.validate(async valid => {
        if (!valid) return
        this.loadingState = this.$loading({
          lock: true,
          text: '打卡中，请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        if (this.$route.path.includes('add_employees')) {
          this.isSetInfo = 1
          this.submitIdCardForAddUser(this.readData)
        } else {
          this.isSetInfo = 0
          this.submitClockData(this.readData)
        }
      })
    },
    /**
     * 关闭打卡弹窗
     */
    closeClockForm() {
      this.loadingState?.close()
      this.codeVisible = false
      this.sendClockCommand()
    },
    /**
     * 显示退出确认对话框
     */
    async showUserDialog() {
      const confirmResult = await this.$confirm('您确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消了退出!')
      }
      // 关闭WebSocket连接
      if (this.readyState === 1) {
        this.websockets.send([{}])
      } else {
        this.websockets?.close()
      }
      sessionStorage.setItem('clockFun', true)
      this.$store.dispatch('user/logout')
      this.$message.success('退出成功!')
      this.$router.push('/login')
    },
    /**
     * 打开修改密码弹窗
     */
    changePassword() {
      this.dialogFormVisible = true
    },
    /**
     * 获取菜单列表
     */
    getMenuList() {
      // 从store获取菜单数据
      this.menulist = this.$store.getters.menus
    },
    /**
     * 切换侧边栏折叠状态
     */
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
      this.$store.commit('user/set_userCard', !this.$store.state.user.userCard)
    },
    /**
     * 获取短信验证码
     */
    getShortMessageCode() {
      this.$refs.loginFormRef.validateField('mobile', async errMsg => {
        if (errMsg) return
        const res = await user.getCode(this.loginForm.mobile)
        if (res.status === 0) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
        // 验证码倒计时
        if (!this.timer) {
          this.count = SMS_COUNTDOWN_SECONDS
          this.show = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= SMS_COUNTDOWN_SECONDS) {
              this.count--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
      })
    },
    /**
     * 提交修改密码表单
     */
    async handlePasswordSubmit() {
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return
        await user.savepassword({ ...this.loginForm })
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
        this.$message.success('修改成功，请重新登陆！')
      })
    }
  }
}
</script>
<style lang="less" scoped>
// 主容器样式
.el-container {
  height: 100%;
  padding-top: 35px;
}
// 首页容器
.home-container {
  height: 100%;
  background-color: #ffffff;
  /deep/ .is-active {
    background-color: #6345d5 !important;
    color: #ffffff !important;
  }
  // 用户信息区域
  .userInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 67px;
    .headPhoto {
      width: 120px;
      height: 120px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }
    }
  }
}
// 滚动条隐藏
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
// 用户头像样式
.user-avatar {
  width: 100%;
  height: 100%;
}
// 用户名样式
.userName {
  margin: 10px 0;
  font-size: 24px;
  line-height: 24px;
  font-family: Arial, sans-serif;
  font-weight: bold;
  color: #6b6c78;
}
// 有效期样式
.validityPeriod {
  margin-bottom: 8px;
  width: 165px;
  font-size: 16px;
  font-family: 'Source Han Sans SC', sans-serif;
  font-weight: 500;
  color: #838490;
  span {
    font-family: Arial, sans-serif;
    font-weight: 400;
  }
}
// 修改密码按钮
.reviseBtn {
  padding: 0;
  margin-bottom: 10px;
  width: 119px;
  height: 30px;
  border-radius: 15px;
  font-size: 16px;
  font-family: 'Source Han Sans SC', sans-serif;
  font-weight: 500;
  color: #333;
  background-color: #ffa82c;
}
// 顶部导航栏
.el-header {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  background-color: #6345d5;
  color: #ffffff;
  line-height: 72px;
}
// 折叠按钮
.toggle-button {
  float: left;
  font-size: 10px;
  width: 49px;
  margin-top: 20px;
  line-height: 30px;
  color: #ffffff;
  border: 1px solid #ffffff;
  text-align: center;
  cursor: pointer;
}
// 头部标题
.header-title {
  margin-left: 20px;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
}
// 用户标题区域
.user-title {
  padding: 20px;
  background-color: #2d2da0;
  div {
    margin-top: 10px;
    color: #ffffff;
    padding-left: 5px;
    font-size: 14px;
  }
}
// 头部右侧区域
.header-right {
  line-height: 70px;
  height: 70px;
  background-color: #ffffff;
  color: #4d505b;
  font-size: 12px;
  float: right;
  .user-menu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
    font-family: 'Adobe Heiti Std', sans-serif;
    font-weight: normal;
    color: #ffffff;
    span {
      height: 16px;
      line-height: 16px;
    }
  }
  .logout {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 22px;
    cursor: pointer;
    img {
      padding-left: 23px;
      padding-right: 8px;
      border-left: 2px solid #482fa6;
      width: 18px;
      height: 18px;
    }
    span {
      font-size: 16px;
      font-family: 'Source Han Sans SC', sans-serif;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
// 头部搜索
.header-search {
  font-size: 14px;
  width: 30px;
  padding: 0px 30px;
  padding-top: 22px;
}
// 头部标题图标
.header-title-icon {
  > img {
    margin: 0px 20px;
  }
}
// 头部下拉图标
.header-title-icon-pull {
  > img {
    width: 15px;
    height: 15px;
    margin-top: 10px;
  }
}
// 用户系统区域
.user-system {
  display: flex;
  background-color: #6345d5;
  color: #ffffff;
  float: right;
  width: 100%;
  height: 70px;
  .title-user {
    display: flex;
    align-items: center;
    margin-right: 15px;
    .icon-user {
      height: 32px;
      width: 36px;
    }
  }
}
// 底部区域
.el-footer {
  background-color: #ffffff;
  line-height: 30px;
  color: #333333;
  font-size: 10px;
  text-align: center;
  height: 30px !important;
}
// 侧边栏
.el-aside {
  margin-top: 100px;
  background-color: #ffffff;
  overflow: hidden;
  .el-menu {
    border-right: none;
    .is-active {
      color: #ffffff !important;
    }
  }
}
// 主内容区域
.el-main {
  background-color: #f3f3f4;
}
// 图标字体
.iconfont {
  margin-right: 10px;
}
// 弹窗样式
.dialog {
  border-radius: 10px;
  overflow: hidden;
  /deep/ .el-dialog__header {
    border-radius: 10px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    width: 100%;
  }
}
// 弹窗标题
.dialog-title {
  font-size: 20px;
  font-weight: 500;
  color: #6345d5;
  border-bottom: 1px solid #6345d5;
  padding-bottom: 10px;
}
// 弹窗头部图片
.dialog-header-img {
  width: 100%;
}
// 打卡表单
.clock-form {
  width: 500px;
}
// 底部按钮居中
.dialog-footer-center {
  width: 200px;
  margin: 0 auto;
}
// 下拉链接
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
}
// 下拉箭头
.el-icon-arrow-down {
  font-size: 12px;
}
// 输入框区域
.input-div {
  /deep/ .el-input__inner {
    position: relative;
    height: 50px;
    padding: 0 20px;
    font-size: 16px;
    border: 1px solid #c1c0d0;
    border-radius: 4px;
  }
  .pr {
    position: relative;
  }
  // 验证码按钮
  .sms_code-btn {
    width: 100px;
    height: 26px;
    position: absolute;
    top: 10px;
    right: 5px;
    z-index: 222;
    color: #a64a26;
    font-size: 14px;
    border: none;
    border-left: 1px solid #bababa;
    padding-left: 10px;
    background-color: #ffffff;
    cursor: pointer;
  }
  /deep/ .dialog {
    border-radius: 18px !important;
    min-width: 800px;
    font-size: 16px;
  }
}
// 打卡提示
.clock-in-tip {
  margin-right: 15px;
  color: #ffffff;
  .danger-text {
    color: #f56c6c;
  }
}
</style>
